const fixtures = {
  user: {
    email: 'dev@theminte.com',
    password: '123456'
  },
  clients: {
    members: {
      userID: 40,
      firstName: 'Jon',
      lastName: 'Ogolo',
      email: 'ogoloj+testing10@gmail.com',
      phone: '7034892424',
      createdAt: '2019-08-29T16:56:05.959Z',
      role: 'member',
      status: 'active',
      dataSource: null,
      isSocial: null,
      facebookID: null,
      googleID: null,
      regionID: null,
      lastLoggedAt: null,
      hasPets: true,
      optInNewsLetter: true,
      customerID: null,
      ccLast4: null,
      ccExpiry: null,
      ccBrand: null,
      isApplePay: null,
      isGooglePay: null,
      propertyID: null,
      propertyName: 'propertyName',
      buildingName: 'Building Name',
      internalNotes: null,
      isVIP: true,
      isRecurring: true,
      averageRatings: true,
      totalCompletedServices: 432,
      isTextNotificationAllow: null,
      unitNumber: '234',
      isKeyReleaseSigned: null,
      bedroomsCount: 4,
      regionName: null,
      regionTZ: null
    },
    pagination: { count: 36, currentPage: 1, pages: 1 }
  },
  requests: {
    list: {
      createdAt: '2019-08-29T16:56:05.959Z',
      houseKeeper: 'House Keeper name',
      timeFrame: 'Morning',
      status: 'In Progress',
      service: 'Hotel-Style',
      name: 'Tauqeer Hassan',
      isVIP: true,
      office: 'CH',
      city: 'Chicago',
      state: 'Washington',
      propertyName: 'Property Name',
      buildingName: 'Building 31',
      unitNumber: 4,
      bedroomsCount: 4,
      hasPets: true,
      additionalInstructions: 'Lorem Ipsum has been the',
      notes:
        'Lorem Ipsum is simply dummy text of the' +
        ' printing and typesetting industry. Lorem Ipsum has been the ',
      price: 123
    },
    pagination: { count: 36, currentPage: 1, pages: 1 }
  },
  coupons: {
    discount: 100,
    status: 'active',
    usagePerUser: 2,
    usageTotal: 2,
    office: 'Washington',
    propertyID: 2,
    serviceType: '1x',
    cleanType: 'Hotel-Style',
    recurrences: 2,
    title: 'Coupon Title',
    aliases: [
      { name: 'mkkjhkug', status: '', used: 10 },
      { name: '333223', status: '', used: 3 },
      { name: '321312', status: '', used: 44 }
    ],
    createdAt: '2019-08-29T16:56:05.959Z',
    expiry: '2019-08-29T16:56:05.959Z'
  },
  properties: {
    properties: {
      activeAt: '2019-08-13T00:00:00.000Z',
      address: '1700 Germany Rd',
      bedroomsCounts: ['1', '2', '3', '4'],
      buildingsNames: ['Name 1', 'Name 2'],
      city: 'Washington',
      firstDayOfService: '2019-09-01T00:00:00.000Z',
      isBuildingRequired: false,
      keyRelease: 'Yes',
      keyReleaseEmail: 'ogoloj@gmail.com',
      name: 'Rothschild',
      propertyID: 3,
      regionID: 1,
      state: 'DC',
      status: 'active',
      unitsCount: 500,
      zipcode: '20000'
    },
    pagination: { count: 36, currentPage: 1, pages: 1 }
  },
  users: {
    users: {
      createdAt: '2019-08-12T11:33:08.827Z',
      dataSource: null,
      email: 'dev@theminte.com',
      facebookID: null,
      firstName: 'Super',
      googleID: null,
      isSocial: null,
      lastLoggedAt: '2019-09-11T20:44:46.919Z',
      lastName: 'Admin',
      phone: '11111111111',
      regionID: null,
      resetPasswordHash: null,
      resetPasswordHashExpiry: null,
      role: 'super_admin',
      status: 'active',
      userID: 1
    },
    pagination: { count: 36, currentPage: 1, pages: 1 }
  }
};

export default fixtures;
